export default __webpack_public_path__ + "static/media/prezencne-pk-5-button.daf8d112.svg";